import { common, IOHelper, JSONHelper, utils, } from '@neo-one/client-common';
import { ContractParameterBase } from './ContractParameterBase';
import { ContractParameterType } from './ContractParameterType';
export class Hash256ContractParameter extends ContractParameterBase {
    constructor(value) {
        super();
        this.type = ContractParameterType.Hash256;
        this.value = value;
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfUInt256);
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        super.deserializeContractParameterBaseWireBase(options);
        const value = reader.readUInt256();
        return new this(value);
    }
    get size() {
        return this.sizeInternal();
    }
    asBuffer() {
        return common.uInt256ToBuffer(this.value);
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeUInt256(this.value);
    }
    serializeJSON(_context) {
        return {
            type: 'Hash256',
            value: JSONHelper.writeUInt256(this.value),
        };
    }
}

//# sourceMappingURL=Hash256ContractParameter.js.map
